import React, { Component } from 'react';
import { Container, Grid, Typography, Button, Link } from '@material-ui/core';
import './index.css';

/**
 * Received RMA screen
 *
 * @version 1.0.0
 */
class ReceivedRMAScreen extends Component {

  /**
   * Renderer
   *
   * @return {JSX} - the to render JSX.
   * @version 1.0.0
   */
  render() {
    return (
      <React.Fragment>
        <Container>
          <Grid container justify="center">
            <Grid item xs={12} lg={8}>
              <Typography variant="h6" gutterBottom className="pageTitle">Retouraanmelding ontvangen</Typography>
              <Typography variant="body1" gutterBottom>We nemen op werkdagen <strong>binnen 24 uur</strong> contact met je op over je retourzending! in de tussentijd kan je jouw retour altijd terug vinden in mijn account</Typography>
              <Typography variant="body1" gutterBottom>Je hebt gemiddeld al <strong>binnen 3 uur</strong> reactie, hierna helpen wij jou verder met opsturen van de retourzending.</Typography>
              <Typography variant="body1" gutterBottom><strong>We sturen je een bevestiging van je retourzending op de mail!</strong></Typography>

              <Grid item xs={5}>
                <Button variant="contained" color="primary" className="confirmButton sendItemBtn">
                  <Link href="https://www.fixjeiphone.nl/mijn-account/" color="inherit">
                    Naar Mijn account
                  </Link>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    );
  }
}

export default ReceivedRMAScreen;
